import { version as versionRaw } from "../../static/version.json";

const apiUrl = window.g.apiUrl;
const wsUrl = window.g.wsUrl;
const ossBaseUrl = window.g.ossBaseUrl;
const arms = window.g.arms; // ARMS开关
const armsEnvironment = window.g.armsEnvironment; // ARMS环境 'prod'|'gray'|'pre'|'daily'|'local'

const version = versionRaw;

export { apiUrl, wsUrl, ossBaseUrl, version, arms, armsEnvironment };
